import _ from "lodash";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import withDynamicUrlValidation from "UIComponents/DynamicUrlValidator";
import UnitPlanDetails from "UnitPlanDetails";
const VALID_DP_ROUTES = [
  "syllabusContent",
  "syllabusOutline",
  "assessmentObjectives",
  "aims",
  "lpas",
  "learning-outcomes",
  "horizontal-lpas",
  "standards",
  "horizontal-connections",
  "connections",
  "timeline",
];
const OLD_PYP_ROUTES = [
  "poi",
  "atls",
  "themeFocusAreas",
  "keyConcepts",
  "learnerProfile",
  "subjects",
];
const validateFunction = ({ path, pathName }) => {
  if (pathName === ":insightChildRoute") {
    // allow numbers as child routes since they are used for custom datasets
    return _.isNaN(path) ? _.includes(VALID_DP_ROUTES, path) : true;
  }
};
export default store => ({
  path: ":insightChildRoute",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "organization-educatorCenter" */ "./Components/InsightV2"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return withDynamicUrlValidation({
          component,
          urlValidationType: "customValidation",
          customUrlValidationFunction: validateFunction,
        });
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter(nextState, replace) {
    const { location: { pathname } = {}, params = {} } = nextState;
    const insightChildRoute = params.insightChildRoute;
    const isRouteValid = _.includes(VALID_DP_ROUTES, insightChildRoute);

    // Old routes have been moved under 'programmeOverview' route
    if (!isRouteValid) {
      if (_.includes(OLD_PYP_ROUTES, insightChildRoute)) {
        const newPath = _.replace(
          pathname,
          insightChildRoute,
          `programmeOverview/${insightChildRoute}`
        );
        replace(newPath);
      }
    }
  },
  childRoutes: [UnitPlanDetails(store)],
});
